import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "react-quill/dist/quill.snow.css";
import "./i18n/config";
import { registerServiceWorker } from "./utils/registerSW";

const rootElement = document.getElementById("root")!;

// Render immediately for faster LCP
createRoot(rootElement).render(<App />);

// Defer non-critical operations
requestIdleCallback(() => {
  // Register service worker for PWA functionality
  if (import.meta.env.PROD) {
    registerServiceWorker();
  }
  
  // Initialize Web Vitals tracking (very low priority)
  import("./lib/web-vitals").then(({ initWebVitals }) => {
    initWebVitals();
  });
}, { timeout: 3000 });
